import axios from 'axios'

const BASE_URL = 'https://appapi.hebei.com.cn/api/2026jyjsjlyhd/api'
const request = axios.create({
  timeout: 30000
})
function stringifyData(data) {
  return JSON.stringify(data)
}

function postForm(url, params) {
  var data = new URLSearchParams()
  Object.keys(params).forEach(function(key) {
    data.append(key, typeof params[key] === 'string' ? params[key] : stringifyData(params[key]))
  })
  return request.post(url, data)
}

export function getFwl() {
  return request.get(BASE_URL + '/fwl.php')
}
//学校列表
export function getSchoolList() {
  return request.get(BASE_URL + '/schoollist.php')
}
//学校详情
export function getSchoolDetail(params) {
  return postForm(BASE_URL + '/schoollist_abst.php', { message: stringifyData(params) })
}
//提交接口
export function postReceive(params) {
	return postForm(BASE_URL + '/receive.php', { message: stringifyData(params) })
}
//首页留言列表
export function getMsgList(params) {
	return postForm(BASE_URL + '/lylist_sy.php', { message: stringifyData(params) })
}

//各个学校全部留言列表
export function getSchoolAllMsgList(params) {
  return postForm(BASE_URL + '/lylist_each_1.php', { message: stringifyData(params) })
}

//各个学校教师祝福留言列表
export function getSchoolTeacherMsgList(params) {
  return postForm(BASE_URL + '/lylist_each_2.php', { message: stringifyData(params) })
}
